import RespondentsSearch from './respondentSearch.container';

export default RespondentsSearch;